import React from "react";
import { FiActivity, FiUsers, FiCalendar, FiCheckCircle, FiClock, FiGrid } from "react-icons/fi";

const icons = {
  activity: FiActivity,
  users: FiUsers,
  calendar: FiCalendar,
  completed: FiCheckCircle,
  clock: FiClock,
  groups: FiGrid,
};

const KioskMetricCard = ({ label, value, helper, icon = "activity", accent = "blue" }) => {
  const Icon = icons[icon] || FiActivity;
  const accentClasses = accent === "green"
    ? "bg-emerald-50 text-emerald-600"
    : accent === "amber"
      ? "bg-amber-50 text-amber-600"
      : "bg-sky-50 text-[#0075AC]";

  return (
    <article className="bg-white border border-slate-200/80 rounded-2xl p-5 shadow-sm min-h-[145px]">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-xs font-bold uppercase tracking-wider text-slate-400 font-display">{label}</p>
          <p className="mt-3 text-3xl font-bold text-[#1D1F3F] tracking-tight">{value}</p>
        </div>
        <div className={`w-10 h-10 rounded-full flex items-center justify-center ${accentClasses}`}>
          <Icon className="w-5 h-5" />
        </div>
      </div>
      {helper && <p className="mt-3 text-xs font-medium text-slate-500">{helper}</p>}
    </article>
  );
};

export default KioskMetricCard;
